import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useScoring, isRedZone } from '../lib/scoring';
import {
  LargeTitle, ListGroup, ListRow, Monogram, ScorePill, SearchField, PageSkeleton, EmptyRow,
} from '../components/ui';

export default function Clinics() {
  const { profile } = useAuth();
  const { threshold, weights } = useScoring();
  const [search, setSearch] = useState('');
  const [clinics, setClinics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!profile?.id) return;
    api.clinics.list()
      .then((list) => {
        setClinics(list);
        list.slice(0, 10).forEach((c) => api.prefetchClinic(c.id));
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [profile?.id]);

  if (loading) return <PageSkeleton hero={false} />;

  const shown = clinics.filter((c) => c.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <LargeTitle title="Clinics" subtitle={`${clinics.length} clinic${clinics.length !== 1 ? 's' : ''}`} />
      {clinics.length > 6 && <SearchField value={search} onChange={setSearch} placeholder="Search clinics" />}
      <ListGroup>
        {shown.length === 0 && <EmptyRow>No clinics found</EmptyRow>}
        {shown.map((clinic) => (
          <ListRow
            key={clinic.id}
            to={`/clinics/${clinic.id}`}
            leading={<Monogram name={clinic.name} score={clinic.avg_cscore} src={clinic.image_url} />}
            title={clinic.name}
            subtitle={`${clinic.clinician_count} clinician${clinic.clinician_count !== 1 ? 's' : ''}`}
            trailing={(
              <ScorePill
                score={clinic.avg_cscore}
                flagged={isRedZone(clinic.avg_cscore, threshold)}
                breakdown={clinic.breakdown}
                weights={weights}
                title={`${clinic.name} average`}
              />
            )}
          />
        ))}
      </ListGroup>
    </div>
  );
}
